import api from '../../lib/api';
import { ExternalRecipient } from './types';

export interface ExternalRecipientResponse {
  data: ExternalRecipient[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    pages: number;
  };
}

export interface CreateExternalRecipientPayload {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  role?: string;
}

export interface UpdateExternalRecipientPayload {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  role?: string;
  active?: boolean;
}

export const fetchExternalRecipients = async (params?: {
  search?: string;
  page?: number;
  pageSize?: number;
  includeInactive?: boolean;
  signal?: AbortSignal;
}): Promise<ExternalRecipientResponse> => {
  const { search = '', page = 1, pageSize = 50, includeInactive = false, signal } = params || {};
  const { data } = await api.get<{ success: boolean; data: ExternalRecipient[]; pagination: ExternalRecipientResponse['pagination'] }>(
    'external-recipients',
    {
      params: { search, page, pageSize, includeInactive },
      signal,
    }
  );
  return {
    data: data.data,
    pagination: data.pagination,
  };
};

export const createExternalRecipient = async (
  payload: CreateExternalRecipientPayload
): Promise<ExternalRecipient> => {
  try {
    const { data } = await api.post<{ success: boolean; data: ExternalRecipient }>(
      'external-recipients',
      payload
    );
    return data.data;
  } catch (error: any) {
    if (error?.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    if (error?.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw error;
  }
};

export const updateExternalRecipient = async (
  id: string,
  payload: UpdateExternalRecipientPayload
): Promise<ExternalRecipient> => {
  try {
    const { data } = await api.put<{ success: boolean; data: ExternalRecipient }>(
      `external-recipients/${id}`,
      payload
    );
    return data.data;
  } catch (error: any) {
    if (error?.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    if (error?.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw error;
  }
};

export const deleteExternalRecipient = async (id: string): Promise<void> => {
  try {
    await api.delete(`external-recipients/${id}`);
  } catch (error: any) {
    if (error?.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    if (error?.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw error;
  }
};